import React, { useCallback, useContext, useEffect } from 'react'
import dayjs from 'dayjs'

// import TimeWindowSelectorButton from '../../../../elem/chart/TimeWindowSelectorButton'
import ParamSelectorButton from '../../../elem/chart/ParamSelectorButton'
import ResetDropDownButton from '../../../elem/chart/ResetDropDownButton'
import ChartDownloadButton from '../../../elem/chart/ChartDownloadButton'

import { DataContext } from './DataContext'
import ExpandButton from '../../../elem/list/ExpandButton'
import { ParameterContext } from '../../../wrappers/ParameterContext'
import { generateDateParams } from '../../../../utils/chart/values'
import downloadChartXlsx from '../../../../utils/chart/downloadChartXlsx'

const formatResultValue = value => {
    if (value === null || value === undefined || value === '') return ''
    const num = Number(value)
    if (Number.isNaN(num)) return value
    return Number(num.toFixed(4))
}

const ChartControls = () => {
    const {
        displayParamWindowDropdown,
        toggleParamWindowDropdown,
        visibleChartTab,
        paramResetExpanded,
        toggleParamResetExpanded,
        paramChartData,
        selectedParams,
        selectedUnits,
        detailData,
        left,
        right,
    } = useContext(DataContext)
    const { isExpanded, setIsExpanded } = useContext(DataContext)
    const { params } = useContext(ParameterContext)

    const handleDownload = useCallback(() => {
        if (!selectedParams || !selectedParams.length || !paramChartData || !paramChartData.length) {
            return
        }
        const isZoomed = typeof left === 'number' && typeof right === 'number'
        const stationCode = detailData && detailData.well && detailData.well.StationID

        const rows = paramChartData
            .filter(d =>
                selectedParams.find(
                    x => x.ParamID === d.ParamID && x.Units === d.Units
                )
            )
            .filter(d => {
                if (!isZoomed) return true
                const ts = dayjs(d.SampleDate).valueOf()
                return ts >= left && ts <= right
            })
            .sort((a, b) => {
                const dateCompare = dayjs(a.SampleDate).valueOf() - dayjs(b.SampleDate).valueOf()
                if (dateCompare !== 0) return dateCompare
                return (a.ParamAlias || '').localeCompare(b.ParamAlias || '')
            })
            .map(d => {
                return {
                    'Station Code': stationCode,
                    'Sample Date Time': dayjs(d.SampleDate).format('MM/DD/YYYY HH:mm:ss'),
                    'Parameter Name': `${d.ParamAlias} - ${d.Units}`,
                    'Result Value': formatResultValue(d.ResultValue),
                }
            })

        const [filterStart, filterEnd] = generateDateParams(params, 'sample', 'SimpleSampleDate')
        const sampleDateFilterApplied = !!(filterStart || filterEnd)

        downloadChartXlsx({
            headers: ['Station Code', 'Sample Date Time', 'Parameter Name', 'Result Value'],
            rows,
            prefix: 'Details Menu',
            chartName: 'Chemistry Sample Results Chart',
            sampleDateFilterApplied,
            isZoomed,
        })
    }, [paramChartData, selectedParams, selectedUnits, detailData, left, right, params])

    const downloadDisabled =
        visibleChartTab !== 'sampleResult' ||
        !selectedParams ||
        !selectedParams.length ||
        !paramChartData ||
        !paramChartData.length

    return (
        <div className="chartControlsWrapper columns">
            <div className="column is-10">
                {visibleChartTab === 'sampleResult' ? (
                    <>
                        <div className="columns is-justify-content-center">
                            <div>
                                <ResetDropDownButton
                                    inHeader={false}
                                    resetExpanded={paramResetExpanded}
                                    toggleResetExpanded={
                                        toggleParamResetExpanded
                                    }
                                />
                            </div>
                            <div>
                                <ParamSelectorButton
                                    inHeader={false}
                                    displayParamWindowDropdown={
                                        displayParamWindowDropdown
                                    }
                                    toggleParamWindowDropdown={
                                        toggleParamWindowDropdown
                                    }
                                />
                            </div>
                        </div>
                        {/* <TimeWindowSelectorButton
                                inHeader={false}
                                timeWindow={timeWindow}
                                displayTimeWindowDropdown={displayTimeWindowDropdown}
                                toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                            /> */}
                    </>
                ) : null}
                {visibleChartTab === 'depth' ? <></> : null}
            </div>
            <ExpandButton
                name={`DetailChart`}
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
            />
            {visibleChartTab === 'sampleResult' ? (
                <ChartDownloadButton
                    name={`DetailChart-sampleResult`}
                    onDownload={handleDownload}
                    disabled={downloadDisabled}
                />
            ) : null}
        </div>
    )
}

export default ChartControls
